import React from 'react';
import { t } from '../../i18n';

const StatsCard = ({ 
  icon, 
  title, 
  value, 
  status, 
  statusText, 
  statusColor, 
  bgColor, 
  iconColor, 
  lang 
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <div className={`w-12 h-12 ${bgColor} rounded-xl flex items-center justify-center`}>
            {icon}
          </div>
        </div>
        <div className="ml-4">
          <p className="text-sm font-medium text-gray-500">
            {t(title, lang) || title}
          </p>
          <p className="text-2xl font-bold text-gray-900">
            {value}
          </p>
          {status && (
            <div className="flex items-center mt-1">
              <div className={`w-2 h-2 ${statusColor} rounded-full mr-2`}></div>
              <span className={`text-xs ${statusColor.replace('bg-', 'text-')} font-medium`}>
                {t(statusText, lang) || statusText}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatsCard; 